<template>
  <div class="poster-block">
    <!--googleoff: noindex-->
    <TeaserBlock
      v-bind="props"
      :aria-hidden="!isMobile"
      class="block"
      :padded="padded"
      :aspect-ratio="props.aspectRatioBlock"
      :loading="loading"
      :priority="priority"
      :show-date="showDate"
      :show-label="showLabel"
      :heading-level="props.headingLevel"
      heading-size="title-lg"
      :analytics="analytics"
    />
    <!--googleon: noindex-->
    <TeaserPoster
      v-bind="props"
      :aria-hidden="isMobile"
      class="poster"
      :aspect-ratio="aspectRatioPoster"
      :fluid="true"
      :loading="loading"
      :priority="priority"
      :show-date="showDate"
      :show-label="showLabel"
      :heading-level="props.headingLevel"
      :analytics="analytics"
    />
  </div>
</template>

<script setup lang="ts">
// switches between poster and block based on breakpoint (using css)
import type {
  IImageLoadingSettings,
  ITeaser,
  TAspectRatio,
  IAnalytics,
} from '~~/types/local_types';
import useBreakpointsStore from '~/stores/breakpoints';
const breakpointsStore = useBreakpointsStore();
const { getCurrentBreakpoint } = storeToRefs(breakpointsStore);
const isMobile = ref<boolean>(true);

interface IProps extends ITeaser, IImageLoadingSettings {
  padded?: boolean;
  showDate?: boolean;
  showLabel?: boolean;
  aspectRatioPoster?: TAspectRatio;
  aspectRatioBlock?: '16x9' | '4x3' | '3x2' | undefined;
  subTitle?: string;
  headingLevel?: number;
  analytics?: IAnalytics;
}

const props = withDefaults(defineProps<IProps>(), {
  loading: 'lazy',
  priority: 'auto',
  padded: false,
  showDate: true,
  showLabel: true,
  aspectRatioPoster: '4x3',
  aspectRatioBlock: '3x2',
  subTitle: '',
  headingLevel: 3,
  analytics: undefined,
});

onMounted(() => {
  watch(
    getCurrentBreakpoint,
    (newValue) => {
      if (newValue) {
        isMobile.value = ['xs', 'sm'].includes(newValue?.name);
      }
    },
    { immediate: true },
  );
});
</script>

<style scoped lang="postcss">
.poster-block {
  display: contents;
}

.block {
  @media (--md-viewport) {
    display: none;
    visibility: hidden;
  }
}

.poster {
  display: none;
  visibility: hidden;

  @media (--md-viewport) {
    display: block;
    visibility: visible;
  }
}
</style>
